import { clearToastError } from "@/redux/shareSlice";
import { store } from "@/redux/store";
import { useState } from "react";

export const usePopupDisplay = () => {
  const [popupVisible, setPopupVisible] = useState(false);

  const hidePopup = () => {
    setPopupVisible(false);
    store.dispatch(clearToastError());
  };

  const showPopUp = () => {
    setPopupVisible(true);
  };

  return {
    popupVisible,
    showPopUp,
    hidePopup,
  };
};
